import { fontBase } from '@/lib/styleUtils';

// Main header container
export const headerClasses = [
  fontBase,
  'tw:box-border',
  'tw:w-full tw:h-auto',
  'tw:bg-primary',
  'tw:flex tw:items-center tw:justify-between',
  'tw:px-base tw:md:pl-huge tw:md:pr-base tw:py-base',
].join(' ');

// Left section: logo only — the nav moved to the right section
export const leftSectionClasses = ['tw:flex tw:items-center tw:gap-colossal'].join(' ');

// Right section: desktop nav + avatar. At md+ this matches the nav's own gap-colossal so the
// avatar sits the same distance from the last nav item as every pair of nav items sits from
// each other — a tighter seam here read as the last item being cramped against the avatar.
// Mobile keeps gap-huge: the desktop nav is hidden there, so this only separates the
// guest Sign In from the avatar, and 48px is too wide for a phone-width header.
export const rightSectionClasses = [
  'tw:flex tw:items-center',
  'tw:gap-huge tw:md:gap-colossal',
].join(' ');

// Logo wrapper
export const logoClasses = ['tw:flex tw:items-center', 'tw:no-underline', 'tw:cursor-pointer'].join(
  ' '
);

// Mobile title (shown instead of logo on some pages)
export const mobileTitleClasses = [
  'tw:text-[#FFFFFF] tw:text-20 tw:font-bold',
  'tw:md:hidden',
].join(' ');

// Navigation link styles
export const navLinkClasses = [
  'tw:text-[#FFFFFF] tw:text-16 tw:font-regular',
  'tw:no-underline',
  'tw:bg-transparent tw:border-0 tw:p-0',
  'tw:cursor-pointer',
  'tw:transition-opacity tw:duration-150',
  'tw:hover:opacity-80',
].join(' ');

// Desktop nav container: primary + secondary items in ONE row, hidden on mobile.
// Both sets share this container so the gap between every pair of items is identical;
// splitting them across two sibling navs made the seam inherit the section's gap.
export const desktopNavClasses = [
  'tw:hidden',
  'tw:md:flex tw:md:items-center tw:md:gap-colossal',
].join(' ');

// Guest sign-in, mobile only. The secondary nav above is desktop-only, so without
// this a signed-out mobile visitor gets no sign-in in the header at all and has to
// hunt for the one in the middle of the page.
export const mobileGuestNavClasses = ['tw:flex tw:items-center', 'tw:md:hidden'].join(' ');

// Avatar wrapper (button reset styles for button element)
export const avatarWrapperClasses = [
  'tw:bg-transparent tw:border-0 tw:p-0',
  'tw:cursor-pointer',
].join(' ');
